export default "__VITE_ASSET__BpXeJki5__"